import { DEFAULT_LOCALE, LOCALE } from '@core/Constants/Locale.constants';
import { Locale } from '@core/Entities/Locale/Locale.entity';

import { getClientSideCookieValue } from './GetClientSideCookieValue';

export const getClientLocale = (): Locale => {
  const locale = getClientSideCookieValue<Locale>(LOCALE);
  return locale || DEFAULT_LOCALE;
};
